import styled from 'styled-components';

const ReactionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  user-select: none;
`;

export default {
  ReactionsWrapper,
};
